// we don't show gap cursor for those nodes
var IGNORED_NODES = [
    'paragraph',
    'bulletList',
    'orderedList',
    'listItem',
    'taskItem',
    'decisionItem',
    'heading',
    'blockquote',
];
export var isIgnored = function (node) {
    return !!node && IGNORED_NODES.indexOf(node.type.name) !== -1;
};
//# sourceMappingURL=is-ignored.js.map